module.exports = __webpack_public_path__ + "static/Icon_GettingStarted_Large-e26847260c0c7924785f70abeda9ecf9.png";